export default __webpack_public_path__ + "static/media/footer-whats.4bcc33b1.svg";